import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslations, languageOptions, Language } from "@/hooks/useTranslations";
import { useCurrency, Currency } from "@/hooks/useCurrency";

// Map languages to default currencies
const languageToCurrency: Record<Language, Currency> = {
  en: "USD",
  ja: "JPY",
  ko: "KRW",
};

const LanguageSelector = () => {
  const { language, setLanguage } = useTranslations();
  const { setCurrency } = useCurrency();

  const handleLanguageChange = (newLanguage: Language) => {
    setLanguage(newLanguage);
    // Auto-set currency based on language
    const suggestedCurrency = languageToCurrency[newLanguage];
    setCurrency(suggestedCurrency);
    window.location.reload();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-1 text-foreground hover:text-muted-foreground transition-smooth">
        <Globe className="w-4 h-4" />
        <span className="text-xs uppercase tracking-wider hidden sm:inline">
          {language.toUpperCase()}
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40 z-[70]">
        {languageOptions.map((option) => (
          <DropdownMenuItem
            key={option.code}
            onClick={() => handleLanguageChange(option.code as Language)}
            className={language === option.code ? "bg-muted" : ""}
          >
            <span className="mr-2">{option.nativeLabel}</span>
            <span className="text-muted-foreground text-xs">({option.label})</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
